import { LitElement, html, css } from '@hh/global.js';

class HHStickyCTA extends LitElement {
  static properties = {
    breakpoint: {
      type: String,
    },
  }

  constructor() {
    super()
    this.isSticky = false
    this.handleResizeBound = this.handleResize.bind(this)
    this.breakpoint = '(min-width: 750px)'
  }

  disconnectedCallback() {
    super.disconnectedCallback()
    window.removeEventListener('resize', this.handleResizeBound)
    if (this.timeoutId) clearTimeout(this.timeoutId)
  }

  firstUpdated() {
    this.formWrapper = this.shadowRoot.querySelector('#formWrapper')
    this.formContainer = this.shadowRoot.querySelector('#formContainer')
    this._initializeObserver()
    this._setWrapperHeightAfterDelay()
    window.addEventListener('resize', this.handleResizeBound)
  }

  isMobile() {
    return !window.matchMedia(this.breakpoint).matches
  }

  handleResize() {
    const mobile = this.isMobile()

    if (mobile && !this.formObserver) {
      this._initializeObserver()
    } else if (!mobile && this.formObserver) {
      this.formObserver.disconnect()
      this.formObserver = null
      this.formContainer.classList.remove(
        'hh-sticky-active',
        'hh-sticky-animate-up'
      )
    }
  }

  _initializeObserver() {
    if (this.isMobile()) {
      const observerOptions = {
        root: null,
        rootMargin: '0px',
        threshold: 0,
      }

      const observerCallback = (entries, observer) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting && !this.isSticky) {
            this.isSticky = true
            this.formContainer.classList.add('hh-sticky-animate-up')
            setTimeout(() => {
              this.formContainer.classList.remove('hh-sticky-animate-up')
              this.formContainer.classList.add('hh-sticky-active')
            }, 200)
          } else if (entry.isIntersecting && this.isSticky) {
            this.isSticky = false
            this.formContainer.classList.add('hh-sticky-animate-up')
            setTimeout(() => {
              this.formContainer.classList.remove('hh-sticky-active')
              this.formContainer.classList.remove('hh-sticky-animate-up')
            }, 200)
          }
        })
      }

      this.formObserver = new IntersectionObserver(
        observerCallback,
        observerOptions
      )
      this.formObserver.observe(this.formWrapper)
    }
  }

  _setWrapperHeightAfterDelay() {
    this.timeoutId = setTimeout(() => {
      const containerHeight = this.formContainer.offsetHeight
      this.formWrapper.style.minHeight = `${containerHeight}px`
    }, 1000)
  }

  render() {
    return html`
      <div id="formWrapper">
        <div id="formContainer">
          <slot></slot>
        </div>
      </div>
    `
  }

  static styles = css`
    :host #formContainer {
      transition: transform 150ms ease-out;
    }

    :host #formContainer.hh-sticky-active {
      z-index: 100;
      left: 0;
      right: 0;
      bottom: 0;
      padding: 1.6rem;
      position: fixed;
      background-color: var(--hh-background, #fff);
    }

    :host #formContainer.hh-sticky-animate-up {
      transform: translateY(100%);
    }
  `
}

customElements.define('hh-sticky-cta', HHStickyCTA)
